import switchedOff from './switched-off';
import switchedOn from './switched-on';

export default {
  switchedOff,
  switchedOn,
};
